module.exports = __webpack_public_path__ + "img/Title_ISE2.8b2981ad.png";